var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50033 0.666626H7.33366C7.83366 0.666626 8.16699 0.999959 8.16699 1.49996V7.33329C8.16699 7.83329 7.83366 8.16663 7.33366 8.16663H1.50033C1.00033 8.16663 0.666992 7.83329 0.666992 7.33329V1.49996C0.666992 0.999959 1.00033 0.666626 1.50033 0.666626Z",
    fill: "#5D78FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.6663 0.666626H16.4997C16.9997 0.666626 17.333 0.999959 17.333 1.49996V7.33329C17.333 7.83329 16.9997 8.16663 16.4997 8.16663H10.6663C10.1663 8.16663 9.83301 7.83329 9.83301 7.33329V1.49996C9.83301 0.999959 10.1663 0.666626 10.6663 0.666626Z",
    fill: "#5D78FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.50033 9.83337H7.33366C7.83366 9.83337 8.16699 10.1667 8.16699 10.6667V16.5C8.16699 17 7.83366 17.3334 7.33366 17.3334H1.50033C1.00033 17.3334 0.666992 17 0.666992 16.5V10.6667C0.666992 10.1667 1.00033 9.83337 1.50033 9.83337Z",
    fill: "#5D78FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.6663 9.83337H16.4997C16.9997 9.83337 17.333 10.1667 17.333 10.6667V16.5C17.333 17 16.9997 17.3334 16.4997 17.3334H10.6663C10.1663 17.3334 9.83301 17 9.83301 16.5V10.6667C9.83301 10.1667 10.1663 9.83337 10.6663 9.83337Z",
    fill: "#5D78FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatform);
export default __webpack_public_path__ + "static/media/platform.6f79df3bfed833efe739ec69161be835.svg";
export { ForwardRef as ReactComponent };